// extracted by mini-css-extract-plugin
module.exports = {"additionalPurchaseOptions":"BundlePricingPageSegment-AdditionalPurchaseOptions-module--additional-purchase-options--1uW8K"};